// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2gn7n","buttons":"Footer_buttons__GWCb4"};